import css from "styled-jsx/css";
import colors from "/styles/colors";

export default css.global`
  .video-carousel-item-component {
    display: flex;
    flex-direction: column;
    align-items: center;

    .video-part {
      position: relative;
      margin: 0 16px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        .play-button-container {
          background-color: ${colors["white-smoke"]};
        }
      }

      .poster-image-wrapper {
        display: flex;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .play-button-container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: white;
        box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.2);
        pointer-events: none;

        .play-button {
          box-sizing: border-box;
          border-color: transparent transparent transparent rgb(51, 51, 51);
          border-style: solid;
          border-width: 9px 0 9px 14px;
          position: absolute;
          left: calc(50% + 2px);
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    &.mobile-layout {
      .video-part {
        overflow: hidden;

        .poster-image-wrapper {
          position: absolute;
          top: 0;
          transition: opacity 0.1s ease-out;
          opacity: 1;
        }
        .video-component-wrapper {
          iframe {
            display: block;
          }
          opacity: 0;
        }
      }
    }

    .title-container.video-title {
      margin-top: 24px;
      .colorful-title {
        font-size: 0.956rem;

        .colored {
          font-weight: bold;
        }
      }
    }
  }
`;
